/**
 * Most MindFlow endpoints wrap responses as { code, message, data }.
 * Auth endpoints return flat shapes. This helper unwraps when the envelope is present.
 */
export function unwrap<T>(raw: unknown): T {
  if (raw && typeof raw === 'object' && 'data' in raw && 'code' in raw) {
    return (raw as { data: T }).data;
  }
  return raw as T;
}
